import { jsxs as h, jsx as f } from "react/jsx-runtime";
import { forwardRef as e } from "react";
const p = ({
  title: l,
  titleId: i,
  ...t
}, a) => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: a, "aria-labelledby": i, ...t, children: [
  l ? /* @__PURE__ */ f("title", { id: i, children: l }) : null,
  /* @__PURE__ */ f("rect", { width: 24, height: 24, fill: "#627eea", rx: 12 }),
  /* @__PURE__ */ f("path", { fill: "#fff", fillOpacity: 0.602, d: "M12.374 3v6.653l5.622 2.512z" }),
  /* @__PURE__ */ f("path", { fill: "#fff", d: "M12.374 3 6.75 12.165l5.624-2.512z" }),
  /* @__PURE__ */ f("path", { fill: "#fff", fillOpacity: 0.602, d: "M12.374 16.476v4.52L18 13.212z" }),
  /* @__PURE__ */ f("path", { fill: "#fff", d: "M12.374 20.996v-4.52L6.75 13.212z" }),
  /* @__PURE__ */ f("path", { fill: "#fff", fillOpacity: 0.2, d: "m12.374 15.43 5.622-3.265-5.622-2.511z" }),
  /* @__PURE__ */ f("path", { fill: "#fff", fillOpacity: 0.602, d: "m6.75 12.165 5.624 3.265V9.654z" })
] }), o = e(p);
export {
  o as default
};
//# sourceMappingURL=sepolia.js.map
